<script>

/**
 * Automodal 
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el controld de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'

import {archetype, automodalHandler} from './archetype'
import DevolucionesGeneralHandler from './DevolucionesGeneralHandler.vue'
import swal from 'sweetalert'
import PreparacionRelacionadoDisplayer from './preparacionRelacionadoDisplayer.vue'

export default {
	components: { DevolucionesGeneralHandler, PreparacionRelacionadoDisplayer },
    name: 'devolucionesAutomodal',
    props: {
        btnClass: {
            type: String,
            default: "btn btn-primary",
        },
        conceptId: {
            type: [String, Number],
        },
        archetype: {
            type: [Array, Object],
            default: () => archetype
        }
    },
    data: () => {
        return {
            form: {
                id: null
            },
            asides: {
                devolucion_detalles: [],
                preparacionRelacionada: null,
            }
        }
    },
    computed: {
        cArchetype(){
            let updated = [];
            _.forEach(archetype, itemsRow => {
                if(!_.isArray(itemsRow)){
                    updated.push(itemsRow);
                    return
                } 
                let adding = []
                _.forEach(itemsRow, item => {
                    // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO

                    // if(item.key == 'key-name'){
                        // DO SOMENTHING
                    // }

                    adding.push(item)
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        async askForFinish($event){
            try {
                let estatusCp = _.clone(this.form.estatus),
                    response = await swal({
                        icon: 'info',
                        title: '¿Seguro que deseas finalizar?',
                        text: 'De ser así, la devolución efectiva se restaurará al inventario. Ésta acción no se puede deshacer.',
                        buttons: {
                            cancel: 'Cancelar',
                            primary: 'Finalizar'
                        }
                    });
                // RESPONSE ANALYSIS
                if(response){
                    this.form.estatus = 'Finalizada';
                    this.$refs.automodal.updateFromModel()
                    this.$refs.automodal.onSubmit($event)
                    this.form.estatus = estatusCp;
                    this.$refs.automodal.updateFromModel()
                }
            } catch (e) {
                console.error(e)
            }
        },
        getHandler(){
            return automodalHandler(this.conceptId)
        },
        refresh(){
            this.$emit('refresh');
        },
        checkAsides(){
            const asides = this.$refs.automodal.getAsides();
            if(asides){
                this.asides.devolucion_detalles     = asides.devolucion_detalles
                this.asides.preparacionRelacionada  = asides.preparacionRelacionada
            }
        },
        onDisplay(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },

    },
    watch: {
        'form.id'(){
            
        }
    }
}
</script>

<template>
    <div>
        <ui-edit-auto-modal v-model="form" ref="automodal" size="xl"  label="Movimiento"
            @refresh="refresh()" 
            @defined="checkAsides()" 
            @display="onDisplay"
            :form-id="form.id" 
            :form-archetype="cArchetype" 
            :handler="getHandler()" 
            :btnClass="btnClass"
            hide-apply-button
            :allow-aside="true" 
            :allow-delete="false">
            <slot name="default"><i class="fa fa-cog"></i></slot>
            <b-col slot="aside" cols="8">
                <!-- LATERAL, REQUIERE :allow-aside="true" -->
                <preparacion-relacionado-displayer :preparacionData="asides.preparacionRelacionada" v-if="asides.preparacionRelacionada"/>
                <devoluciones-general-handler v-model="form.devolucion_detalles" :origen="form.origen" :devolucion-detalles="asides.devolucion_detalles" :readonly="form.estatus != 'En curso'"/>
            </b-col>
            <b-col slot="bottom" v-if="false">
                <!-- AGREGAR AL FONDO... -->
            </b-col>
            <template slot="extra-buttons" v-if="form.estatus == 'En curso'">
                <b-button variant="warning" @click="askForFinish">
                    Finalizar
                </b-button>
            </template>
        </ui-edit-auto-modal>
    </div>
</template>